import { useLocation } from "react-router";
import TableLayout from "../../components/TableLayout";
import { API_URL } from "../../utils/constant";
import { useFetchData } from "../../hooks/useFetchData";
import React, {useState} from "react";

const headers = [
  {
    key: "supplier_name",
    name: "Name",
  },
  {
    key: "email",
    name: "Email",
  },
  {
    key: "phone1",
    name: "Phone",
  },
  {
    key: "status",
    name: "Status",
  },
];

const detailPopupHeaders = [
  {
    key: "supplier_code",
    name: "Supplier ID",
  },
  {
    key: "supplier_name",
    name: "Supplier Name",
  },
  {
    key: "email",
    name: "Supplier Email",
  },
  {
    key: "phone1",
    name: "Phone 1",
  },
  {
    key: "phone2",
    name: "Phone 2",
  },
  {
    key: "phone3",
    name: "Phone 3",
  },
  {
    key: "phone4",
    name: "Phone 4",
  },
  {
    key: "address",
    name: "Address",
  },
];

export default function SupplierList() {
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const currentPath = location.pathname;

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/supplier",
    defaultQuery: "status=ACTIVE",
  });

  const handleSearch = (value) => {
    const trimmed = value.trim();
    if(trimmed.length > 0){
      setSearchValue(trimmed);
      setQuery({
        search: trimmed,
      });
    }else{
        setQuery({});
    }
  };

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Supplier List"
      data={data}
      setQuery={setQuery}
      headers={headers}
      detailPopupTitle="Supplier Information"
      detailPopupHeaders={detailPopupHeaders}
      idKey="supplier_id"
      endPoint="/supplier"
      setCurrentPage={setCurrentPage}
      hasSearch
      hasCreate
      module="Supplier"
      createPath={`/supplier/create`}
      hasActions
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      reload={reload}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
    />
  );
}
